import PropTypes from 'prop-types';

import { Box, Col, Container, Flex } from '../grid';
import { Button } from '../button';
import { ButtonHelper } from './components/primary-button-helper';
import { H2, P } from '../typography';
import { Image } from '../image';
import { navigation } from '../../constants';

const InactiveCompetitionContent = ({ heading, body, setShowButtonHelper, showButtonHelper }) => (
  <Container py={2} textAlign="center" display="flex" flexDirection={{ xs: 'column', lg: 'row' }}>
    <Col
      width={{ xs: 12 / 12, lg: 6 / 12 }}
      display="flex"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      mb={{ xs: 2, lg: 0 }}
    >
      <Box p={3}>
        <Image alt="Barcelo telling a joke" objectFit="contain" src="/static/images/spin-to-win/joke.png" />
      </Box>
    </Col>
    <Col width={{ xs: 12 / 12, lg: 6 / 12 }}>
      <Flex flexDirection="column" alignItems="center" justifyContent="center" height="100%">
        <H2 mb={4}>{heading}</H2>
        <P maxWidth={{ _: '90%', md: '75%' }} mb={3}>
          {body}
        </P>
        <Box position="relative">
          <Button
            onMouseEnter={() => setShowButtonHelper(true)}
            onMouseLeave={() => setShowButtonHelper(false)}
            href={navigation.MENU}
          >
            Browse Menu
          </Button>
          {showButtonHelper && (
            <Box position="absolute" right={0} bottom={-6}>
              <ButtonHelper text="Feeling hungry?" arrowColour="#78D42F" />
            </Box>
          )}
        </Box>
      </Flex>
    </Col>
  </Container>
);

InactiveCompetitionContent.propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  setShowButtonHelper: PropTypes.func.isRequired,
  showButtonHelper: PropTypes.bool.isRequired,
};

export { InactiveCompetitionContent };
